module.exports = "../www/images/update0906.png";